import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PhoneIcon from '@mui/icons-material/Phone';
import Container from 'components/Container';
import { SchoolLocation } from 'context/SchoolContext';
import { Email, Place } from '@mui/icons-material';
import ContactItem from './components/ContactItem';
import GoogleMap from './components/GoogleMap';
import Link from '@mui/material/Link';

function Contact(props: SchoolLocation): JSX.Element {


  const LeftSide = (): JSX.Element => {
    return (
      <Box>
        <Box marginBottom={2}>
          <Typography variant={'h4'} sx={{ fontWeight: 700 }} gutterBottom>
            {props.name}
          </Typography>
          {props.description && (
            <Typography color="text.secondary">{props.description}</Typography>
          )}
        </Box>
        <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'space-between'}
          gap={2}
        >
          {props.phone && (
            <ContactItem icon={<PhoneIcon />} label="Phone">
              <Link
                href={`tel:${props.phone}`}
                underline="always"
                color="inherit"
              >
                {props.phone}
              </Link>
            </ContactItem>
          )}
          {props.email && (
            <ContactItem icon={<Email />} label="Email" >
              <Link
                href={`mailto:${props.email}`}
                underline="always"
                color="inherit"
              >
                {props.email}
              </Link>
            </ContactItem>
          )}
          {props.streetAddress && (
            <ContactItem icon={<Place />} label="Address" >
              <Link
                href={`maps://?q=${encodeURIComponent(
                  `${props.streetAddress}, ${props.city} ${props.state} ${props.zip}`
                )}`}
                underline="always"
                color="inherit"
                target="_blank"
                rel="noopener noreferrer"
              >
                {props.streetAddress}
                <br />
                {`${props.city} ${props.state}\u00A0\u00A0${props.zip}`}
              </Link>
            </ContactItem>
          )}
        </Box>


      </Box>
    );
  };

  return (
    <Box
      sx={{
        width: 1,
        height: 1,
        overflow: 'hidden',
      }}
    >
      <Container paddingX={0} paddingY={0} maxWidth={{ sm: 1, md: 1236 }}>
        <Box
          display={'flex'}
          flexDirection={{ xs: 'column', md: 'row' }}
          position={'relative'}
        >
          <Box width={1}>
            <Container>
              <LeftSide />
            </Container>
          </Box>
          <Box
            sx={{
              flex: { xs: '0 0 100%', md: '0 0 50%' },
              position: 'relative',
              maxWidth: { xs: '100%', md: '50%' },
            }}
          >
            <Box
              sx={{
                width: { xs: 1, md: '50vw' },
                height: '100%',
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  overflow: 'hidden',
                }}
              >
                <Box
                  sx={{
                    overflow: 'hidden',
                    left: '0%',
                    width: 1,
                    height: 1,
                    position: { xs: 'relative', md: 'absolute' },
                  }}
                >
                  <GoogleMap
                    streetAddress={props.streetAddress ?? ''}
                    city={props.city ?? ''}
                    state={props.state ?? ''}
                    zip={props.zip ?? ''}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Contact;
